import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import OurPrograms from "./sections/OurPrograms";
import Faculty from "./sections/Faculty";
import FAQ from "./sections/FAQ";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutUs />
      <OurPrograms />
      <Faculty />
      <FAQ />
      <Contact />
      <Footer />
    </div>;
}